import PropTypes from 'prop-types';
import { STATIC_OON_MARKER_URL, STATIC_MARKER_URL } from "./utils/constants";
import { colorScheme } from "./utils/mapScheme";
import getMarkerScheme from "./utils/getMarkerScheme";
import getStaticMapScheme from "./utils/getStaticMapScheme";
import { createGoogleAPIFragment } from "../../../utils/StaticMap/constants";
import { jsx as _jsx } from "react/jsx-runtime";
function ProgramDetailStaticMap(_ref) {
  let {
    providerLicensed,
    latLng,
    zoom,
    googleApiKey
  } = _ref;
  const width = '470';
  const height = '200';
  const scale = '2';
  const icon = providerLicensed ? STATIC_MARKER_URL : STATIC_OON_MARKER_URL;
  const markers = `&markers=${getMarkerScheme({
    latLng,
    icon,
    scale
  })}`;
  const mapSize = `&size=${width}x${height}`;
  const mapScale = `&scale=${scale}`;
  const mapScheme = `&${getStaticMapScheme(colorScheme)}`;
  const mapZoom = `&zoom=${zoom}`;
  const STATIC_API_URL = createGoogleAPIFragment(googleApiKey);
  const mapSrc = `${STATIC_API_URL}${markers}${mapScheme}${mapSize}${mapScale}${mapZoom}`;
  return /*#__PURE__*/_jsx("img", {
    alt: "map",
    className: "static-map",
    height: height,
    src: mapSrc
  });
}
ProgramDetailStaticMap.propTypes = {
  providerLicensed: PropTypes.bool.isRequired,
  latLng: PropTypes.arrayOf(PropTypes.number).isRequired,
  zoom: PropTypes.string,
  googleApiKey: PropTypes.string.isRequired
};
ProgramDetailStaticMap.defaultProps = {
  zoom: '15'
};
export default ProgramDetailStaticMap;
//# sourceMappingURL=ProgramDetailStaticMap.js.map